<template>
  <div class="production_wrap">
    <div class="production_img" id="cpjz">
      <div class="production_img_inner">
        <div class="img_desc">良悦无人值守计量节点解决方案</div>
        <div class="img_tit">全自动监测，精准数据，远程管控</div>
<!--        <div class="img_desc">从设计到交付，数字化全链贯通，一站式数字化制造服务，让效率与质量双擎驱动</div>-->
        <router-link class="img_btn" to="/Experience">立即咨询</router-link>
      </div>

    </div>
    <div class="tab-area hidden-xs-only">
      <div class="tab-area-bg"></div>
      <el-tabs v-model="activeName" @tab-click="handleClick" class="tabs">
        <el-tab-pane label="系统定位" name="first"></el-tab-pane>
        <el-tab-pane label="业务场景" name="second"></el-tab-pane>
        <el-tab-pane label="核心功能" name="third"></el-tab-pane>
        <el-tab-pane label="设备支持" name="fourth"></el-tab-pane>
        <el-tab-pane label="关联模块" name="five"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="service-card" >
      <div class="production_inner">
        <div class="inner_center">
          <div class="production_title">系统定位</div>
          <div class="production_desc">全流程自动化计量的智能枢纽 </div>
        </div>
      </div>

      <div class="production_box" >
        <div class="production_item">
          <div class="title">
            <el-row>
              <el-col :span="3" :xs="5">
                <img  src="../../assets/img/solution/zdxth.png"/>
              </el-col>
              <el-col :span="18" :xs="19">
                <div>零人工干预</div>
                <div class="content">通过智能设备与算法实现计量全流程自动化，减少人为误差与人力成本</div>
              </el-col>
              <el-col :span="3" class="hidden-xs-only">

              </el-col>
            </el-row>
          </div>
        </div>
        <div class="production_item">
          <div class="title">
            <el-row>
              <el-col :span="6" class="hidden-xs-only">
                &nbsp;
              </el-col>
              <el-col :span="3" :xs="5">
                <img  src="../../assets/img/solution/kcjzh.png"/>
              </el-col>
              <el-col :span="15" :xs="19">
                <div>实时精准监控</div>
                <div class="content">毫秒级数据采集与异常预警，提升计量准确率</div>
              </el-col>
            </el-row>

          </div>
        </div>
      </div>
    </div>

    <div class="tedian" >
      <div class="production_title_wrap flow-title">
        <div class="production_inner">
          <div class="inner_center">
            <div class="production_title" >良悦无人值守计量节点解决方案业务流程</div>
          </div>
        </div>
      </div>
      <div class="title_card">
        <img src="../../assets/img/solution/WRZS.svg" class="gaizao hidden-xs-only"/>
        <img src="../../assets/img/solution/WRZS_phone.svg" class="gaizao2 hidden-sm-and-up"/>
      </div>
      <div class="production_title_wrap flow-title">
        <div class="production_inner">
          <div class="inner_center">
            <div class="production_title" id="cptd">业务场景</div>
          </div>
        </div>
      </div>
      <div class="production_card">
        <img src="../../assets/img/solution/WRZS_scenario.png" class="gaizao"/>
      </div>
    </div>

      <div class="production_title_wrap" >
        <div class="production_inner">
          <div class="inner_center">
            <div class="production_title"  id="fwfc">核心功能</div>
          </div>
        </div>

        <el-row class="card_wrap " type="flex" >
          <el-col
              class="brain_item"
              :lg="5"
              :sm="11"
              :xs="24"
              v-for="(item, index) in cardList"
              :key="index"
          >

          <div class="item_bg"></div>
              <el-row style="z-index: 2">
                <el-col :span="24" :xs="6">
                  <div class="item_bg_div"><img :src="item.src" alt="" class="img_item"/></div>
                </el-col>
                <el-col :span="24" :xs="18" class="con">
                  <div class="item_title">{{ item.title }}</div>
                  <div class="item_desc hidden-xs-only" :style="item.title==='集中管理'?{ textAlign : 'center' }:{}">{{ item.desc1 }}</div>
                  <div class="item_desc hidden-sm-and-up">{{ item.desc1 }}</div>
                </el-col>
              </el-row>

              <!--        <div class="item_title">{{ item.title }}</div>-->
              <!--        <div class="item_desc">{{ item.desc }}</div>-->
              <!--        <div class="item_navigate" @click="handleNavigate">了解详情 >></div>-->
              <!--        <div class="item_bg"></div>-->
            </el-col>
          </el-row>
        <span id="gzfx"></span>
      </div>
    <div class="tedian1"  >
      <div class="production_title_wrap">
        <div class="production_inner">
          <div class="inner_center">
            <div class="production_title">设备支持</div>
          </div>
        </div>
      </div>
      <div class="production_card">
        <el-row class="row-area" id="glmk">
          <el-col :span="3" :xs="6" class="col-area">
            <img src="../../assets/img/solution/gjd.svg" />高精度传感器
          </el-col>
          <el-col :span="3" :xs="1">
            <el-divider direction="vertical" />
          </el-col>
          <el-col :span="5" :xs="5" class="col-area">
            <img src="../../assets/img/solution/byjswg.svg" />边缘计算网关
          </el-col>
          <el-col :span="2" :xs="1">
            <el-divider direction="vertical" />
          </el-col>
          <el-col :span="5" class="col-area">
            <img src="../../assets/img/solution/zdjl.svg" />自动计量设备
          </el-col>
          <el-col :span="3" :xs="1">
            <el-divider direction="vertical" />
          </el-col>
          <el-col :span="3" :xs="5" class="col-area">
            <img src="../../assets/img/solution/jksb.svg" />监控设备
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="production_title_wrap">
      <div class="production_inner">
        <div class="inner_center">
          <div class="production_title">关联模块</div>
        </div>
      </div>
      <div class="production_card">
      <el-row :gutter="20" class="guanlian-row-area">
        <el-col :span="12" :xs="24" class="guanlian-col">
          <el-card :body-style="{ padding: '0px' }">
            <img src="../../assets/img/solution/gl1.jpg" class="image">
            <span class="guanli-title">纵向关联</span>
            <div class="guanli-area">
              <el-row>
                <el-col :span="12" :xs="24">
                  <span>WMS</span>
                  <div class="time">同步物料批次信息，触发库位分配任务</div>
                </el-col>
                <el-col :span="12" :xs="24">
                  <span>SCM</span>
                  <div class="time">实现物流过程计量信息采集，实现计量数据互通</div>
                </el-col>
                <el-col :span="12" :xs="24">
                  <span>ERP</span>
                  <div class="time">同步到货信息，减少人为误差与人力成本</div>
                </el-col>
              </el-row>



            </div>
          </el-card>
        </el-col>
<!--        <el-col :span="8">-->
<!--          <el-card :body-style="{ padding: '0px' }">-->
<!--            <img src="../../assets/img/solution/gl2.jpg" class="image">-->
<!--            <span class="guanli-title">横向扩展</span>-->
<!--            <div class="guanli-area">-->
<!--              <span>数据中台 、 AI中台</span>-->
<!--            </div>-->
<!--          </el-card>-->
<!--        </el-col>-->
        <el-col :span="12" :xs="24" class="guanlian-col">
          <el-card :body-style="{ padding: '0px' }">
            <img src="../../assets/img/solution/gl3.jpg" class="image">
            <span class="guanli-title">底层数据互通</span>
            <div class="guanli-area">
              <span>SCM、ERP、数据中台、大数据分析平台</span>
              <div class="time">&emsp;</div>
            </div>
          </el-card>
        </el-col>
      </el-row>
      </div>
    </div>
    <div class="tedian1 padding80" >
      <Zixun />
    </div>
    <CallMe />
    <MobileCallme />
  </div>
</template>

<script>
// import ProCard from './ProCard.vue'
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/MobileCallme.vue'
import Zixun from "@/components/zixun/index.vue";
export default {
  data() {
    return {
      activeName:"first",
      cardList: [
        {
          src: require('@/assets/img/solution/sjzt-hx-1.png'),
          title: '多模态数据融合',
          desc1: '支持重量、图像、RFID等多源数据同步采集与交叉验证',
        },
        {
          src: require('@/assets/img/solution/qms-hx-2.png'),
          title: '动态校准引擎',
          desc1: '监控计量过程，通过电子围栏、雷达感知等Iot设备，自动判断计量有效性',
        },
        {
          src: require('@/assets/img/solution/wrzs-hx-3.png'),
          title: '集中管理',
          desc1: '支持多节点集中管理，提高人效',
        },{
          src: require('@/assets/img/solution/wrzs-hx-4.png'),
          title: '智能计量指引',
          desc1: '通过Iot设备、广播等设备指引计量，实现无人值守计量过程',
        }

      ],
      currentSub:""
    }
  },
  components: {
    Zixun,
    CallMe,
    MobileCallme,
  },
  mounted() {
    this.activeName="first"
    let elements = document.querySelectorAll('.tab-area');
    window.onscroll = () => {
      if(document.documentElement.scrollTop > 420){
        elements.forEach(function(element) {
          element.classList.add('tab-area-fixed');
        });
        if(document.documentElement.scrollTop > 500){
          this.activeName="second"
        }
        if(document.documentElement.scrollTop > 1200){
          this.activeName="third"
        }
        if(document.documentElement.scrollTop > 2100){
          this.activeName="fourth"
        }
        if(document.documentElement.scrollTop > 2500){
          this.activeName="five"
        }
      }else {
        this.activeName="first"
        elements.forEach(function (element) {
          element.classList.remove('tab-area-fixed');
        });
      }
    }
  },
  methods:{
    overSub(flag){
      this.currentSub = flag
    },
    outSub(){
      this.currentSub = ''
    },
    handleClick(){
      if(this.activeName==="first"){
        const element = document.getElementById('cpjz');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' ,block: 'start'});
        }
      }
      if(this.activeName==="second"){
        const element = document.getElementById('cptd');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' ,block: 'center'});
        }
      }
      if(this.activeName==="third"){
        const element = document.getElementById('fwfc');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' ,block: 'center'});
        }
      }
      if(this.activeName==="fourth"){
        const element = document.getElementById('gzfx');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' ,block: 'center'});
        }
      }
      if(this.activeName==="five"){
        const element = document.getElementById('glmk');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' ,block: 'start'});
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.flow-title{
  padding-bottom: 0 !important;
}
.tedian1 {
  background-color: rgba(245, 247, 250, 1);
  padding: 5px 0 5px 0;
}
.tedian{
  background-color:#EDF5FF;
  padding: 5px 0 5px 0 ;
  .title_card{
    width: 70%;
    margin: 40px auto 0 auto;
    @media screen and (max-width: 768px) {
      width: 100%;
    }
    img{
      width: 100%;
      margin-bottom: 0;
    }
  }
  .production_card{
    margin-top: 20px !important;
  }

}
.production_wrap {
  width: 100%;
  margin-top: 70px;
  .production_img {
    background: url('../../assets/img/solution/wrzs-bg.jpg') 0 0 no-repeat;
    background-size: 100% 100%;
    @media screen and (max-width: 768px) {
      background-size: cover ;
      background-position: 90% 100%;
    }
  }
  .production_title_wrap {
    width: 100%;
    margin-top: 50px;
    //padding-bottom: 50px;
    @media screen and (max-width: 768px) {
      margin-top: 30px;
    }
  }
  .bottom{
    width: 60%;
    margin: auto;
    text-align: center;
    margin-top: -80px;
    color: rgba(37, 53, 84, 0.5);
    font-size: 14px;
  }
  .production_box {
    margin: auto;
    width: 70%;
    display: flex;
    justify-content: space-between;
    margin-top: 40px;
    margin-bottom: 10px;
    @media screen and (max-width: 768px) {
      width: 95%;
      justify-content: space-around;
      flex-wrap: wrap;
    }
    .bg{
      width: 100%;
      border-radius: 4px;
    }
    .production_item {
      width: calc(100% / 2); /* 减去间距 */
      margin: 8px 0px; /* 可根据需要调整 */
      padding-right: 40px;
      display: flex;
      @media screen and (max-width: 768px) {
        width: 100%;
        margin-left: 0;
        margin-top: 10PX;
        box-shadow: 2px 2px 5px 2px rgba(12, 28, 56, 0.05);
        border-radius: 4px;
        background: rgba(255, 255, 255, 1);
        padding: 20px 10px;
        border: 1px solid rgba(224, 236, 255, 1);
        justify-content: center;
      }
     .title{
       width: 100%;
       font-size: 24px;
       color: rgba(37, 53, 84, 1);
       @media screen and (max-width: 768px) {
         font-size: 0.9rem;
         line-height: 1.5rem;
         font-weight: bold;
       }
       img{
         margin-bottom: 10px;
         width: 60px;
         @media screen and (max-width: 768px) {
           width:40PX;
           //float: left;
           //margin-right: 15PX;
           margin-left: 10PX;
           margin-top: 5PX;
         }
       }
       .content{
         margin-top: 10px;
         font-size: 14px;
         line-height: 24px;
         color: rgba(37, 53, 84, 0.6);
         @media screen and (max-width: 768px) {
         font-size: 0.7rem;
         line-height: 1.2rem;
         //margin-left: 55PX;
         font-weight: normal;
       }

       }
     }
    }
  }
  p {
    text-align: center;
    color: #3b3b3b;
    font-weight: bold;
    font-size: 20px;
    line-height: 100px;
    @media screen and (max-width: 768px) {
      font-size: 0.9rem;
      padding: 15px 0;
    }
  }
  .service-card {
    width: 100%;
    margin: 50px auto;
    background-color: #fff;
  }
  .production_card2 {

    width: 50%;
    margin: 50px auto;
    @media screen and (max-width: 768px) {
      width: 95%;
    }
  }
  .production_card {

    width: 70%;
    margin: 50px auto;
    @media screen and (max-width: 768px) {
      width: 95%;
      margin: 20PX auto;
    }

    .title-div{
      img{
        float: left;
        height: 30px;
        width: 1px;
        margin-top: 5px;
      }
      .title{
        float: left;
        font-size: 32px;
        line-height: 40px;
        font-weight: bold;
        color: #05102F;
        padding-right: 15px;
      }
      .desc{
        float: left;
        font-size: 22px;
        line-height: 40px;
        color: #808080;
        padding-left: 15px;
      }
    }
    .item-content{
      width: 100%;
      display: flex;
      justify-content: center;
      padding: 50px 0;
      .sub-item-yzs{
        border-radius: 4px;
        background: #FFFFFF;
        border: 1px solid #E0ECFF;
        padding: 10px;
        box-shadow: 6px 6px 16px 2px rgba(12, 28, 56, 0.1);
        width: calc(100% / 5 - 10px); /* 减去间距 */
        margin-right: 20px;
        .down-card{
          width: 100%;
          padding: 0 8px 0px 8px;
          color: #808080;
          line-height: 26px;
          font-size: 13px;
        }
        .up-card{
          display: flex;
          line-height: 60px;
          font-size: 22px;
          color: #16181A;
          font-weight: bold;
          img{
            width: 28%;
            margin-right: 5px;
          }
        }
        &:hover{
          box-shadow: 6px 6px 16px 2px rgba(12, 28, 56, 0.2);
          .up-card{
            color: #0052D9;
          }
        }
      }

    }
  }
  .advantage_out_wrap {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .carousel_pro {
    width: 60%;
    margin: 60px auto;
    .carousel_pro_item {
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
}
.basic-area{
  margin: auto;width: 70%;
  padding: 0 14px 30px 14px;

  .title{
    border-radius: 8px;color: #fff;
    background: #3393FD;
    line-height: 40px;
    text-align: center;
  }
  .content{
    border-radius: 8px;
    background: linear-gradient(180deg, #F6F8FF 0%, #D9E6FA 100%);
    border: 2px dashed #a3c4fe;
    width: 100%;
    margin-top: 10px;
    padding: 15px 8px;
    display: flex;
    .content-item{
      padding: 20px;
      text-align: center;
      margin: 0 1%;
      //float: left;
      width: 9%;
      border: 2px dashed #a3c4fe;
      background-color: #FBFDFF;
      border-radius: 8px;
      align-content: center;
      color: #05102F;
    }

  }
}
.production_core_scene{
  background-color: #F5F7FA;
  width: 70%;
  margin: 30px auto;
  padding: 30px 50px 20px 50px;
  height: 350px;
  border-radius: 4px;
  background: linear-gradient(180deg, rgba(2, 99, 255, 1) 41.2%, rgba(131, 181, 254, 1) 100%);
  .production_core_scene_title{
    align-content: center;
    color: #fff;
    letter-spacing: 2px;
    padding-bottom: 20px;
    .sub1{
      font-size: 32px;
      margin-right: 10px;
      font-weight: bold;
      line-height: 40px;
      float: left;
    }
    img{
      float: left;
      height: 30px;
      margin-top: 5px;
      width: 1px;
    }
    .sub2{
      margin-left: 10px;
      font-size: 20px;
      line-height: 40px;
      float: left;
    }
  }
  .item-bg{
    float: left;
    width: 24%;
    img{
      width: 90%;
    }
  }
  .item{
    float: left;
    width: 16%;
    padding: 0 20px;
    margin-left: 3%;
    text-align: center;
    border-radius: 4px;
    background: linear-gradient(0deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 1) 39.8%, rgba(255, 255, 255, 0.8) 64.35%, rgba(255, 255, 255, 0.6) 100%);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 230px;
    font-size: 12px;
    color: #8491AB;
    .bg{
      width: 46%;
    }
    .hx{
      margin: 10px 0;
      width: 100%;
    }
    .btn-area{
      width: 100%;
    }
    .left-div{
      flex: 1;
      width: 48%;
      background: #EBEFF5;
      line-height: 30px;
      border-radius: 4px;
      float: left;
      font-size: 13px;
      margin-right: 2%;
    }
    .right-div{
      width: 48%;
      flex: 1;
      background: #EBEFF5;
      line-height: 30px;
      border-radius: 4px;
      float: left;
      font-size: 13px;
    }
    span{
      font-size: 20px;
      line-height: 40px;
      font-weight: bold;
      color: #253554;
    }
  }

}
.tab-area{
  margin: auto;
  width: 100%;
  .tabs{
    margin: 0 15%;
    margin-top: -50px;
  }
  .tab-area-bg{
    background: #FFFFFF;
    height: 60px;
    box-shadow: 0 4px 12px rgba(12, 28, 56, 0.2);
  }
}
.tab-area-fixed{
  position: fixed;
  top: 70px;
  z-index: 999;
}
::v-deep(.el-tabs__nav-wrap::after){
  background-color: #fff !important;
}
::v-deep(.el-tabs__item ){
  margin-bottom: 10px;
}
::v-deep(.el-tabs__item.is-active ){
  color: #0052D9  !important;
}
::v-deep(.el-tabs__active-bar){
  background-color: #0052D9  !important;
  height: 3px;
}
.shenru-btn {
  width: 180px;
  height: 40px;
  background: #0052D9;
  color: #fff;
  bottom: 15%;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.5s;
  margin: 30px auto 10px auto;
  &:hover {
    color: #fff;
    font-weight: bold;
    background: #24b1ff;
  }
  @media screen and (max-width: 768px) {
    width: 80px;
    height: 30px;
    font-size: 14px;
  }
}
.gaizao{
  width: 100%;
  margin: 0 auto 20px auto;
}
.gaizao2{
  width: 100%;
  margin: 0 auto 20px auto;
  padding: 25PX;
}
.padding80{
  padding-top: 80px
}
.card_wrap {
  width: 70%;
  flex-wrap: wrap;
  margin: 0px auto;
  padding-bottom: 20px;
  justify-content: space-between;
  @media screen and (max-width: 768px) {
    width: 95%;
    padding-bottom: 20PX;
  }
  .brain_item {
    transition: background-color 1s;
    padding: 20px 5px;
    border-radius: 4px;
    margin-top: 40px;
    position: relative;
    @media screen and (max-width: 768px) {
      font-size: 0.8rem;
      line-height: 40PX;
      border-radius: 10PX;
      //justify-content: center;
      margin-top: 20PX;
    }
    .img_item {
      margin-top: 18px;
      width: 60% ;
      @media screen and (max-width: 768px) {
        width:50PX;
        height: 50PX;
        margin-top: 0;
      }
    }
    &:hover{
      //box-shadow: 0 0.5rem 1.5rem 0.5rem rgb(12 28 56 / 18%);
    }
    .item_bg {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      //background: linear-gradient(180deg, #F3F5F8 0%, #FFFFFF 100%);
      //box-shadow: 0 0.5rem 1.5rem 0.5rem rgb(12 28 56 / 12%);
      opacity: 0;
      transition: all 0.5s;
      border-radius: 4px;
      z-index: 1;
      //border: 1px solid #fff;

    }

    .item_bg_div{
      width:100px;
      height:100px;
      background:linear-gradient(180deg, rgba(237, 241, 252, 1) 0%, rgba(255, 255, 255, 1) 100%);
      box-shadow: 0 0.2rem 1rem 0.2rem rgba(12, 28, 56, 0.08);
      border: 2px solid #fff;
      border-radius: 50%;
      text-align: center;
      margin: auto;
      margin-bottom: 20px;
      @media screen and (max-width: 768px) {
        width: 70PX;
        height: 70PX;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 10PX;
      }
      &:hover{
        box-shadow: 0 0.2rem 1.5rem 0.2rem rgba(12, 28, 56, 0.128);
        border: 1px solid #fff;
      }
    }
    &:hover .item_bg{
      opacity: 1;
    }
    &:hover .item_title {
      color: #0052D9;
    }
    //&:hover .item_desc {
    //  color: #0052D9;
    //}
    .item_title {
      transition: all 0.5s;
      font-size: 18px;
      font-weight: bold;
      color: #203040;
      text-align: center;
      padding: 10px 0 10px 0;
      z-index: 2;
      position: inherit;
      @media screen and (max-width: 768px) {
        font-size: 1rem;
        text-align: left;
      }
    }
    .item_desc {
      width: 90%;
      transition: all 0.5s;
      color: #666;
      text-align: left;
      line-height: 24px;
      z-index: 2;
      position: inherit;
      font-size: 13px;
      min-height: 30px;
      margin: auto;
      @media screen and (max-width: 768px) {
        font-size: 0.8rem;
        line-height: 1.2rem;
        margin-left: 0;
      }
      i{
        padding-right: 5px;
        color: #19B21E;
        font-weight: bold
      }
    }
    .item_navigate {
      width: 100PX;
      height: 30PX;
      padding: 0 10px;
      background: #ffa400;
      color: #fff;
      border-radius: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      margin-top: 40px;
      cursor: pointer;
      z-index: 2;
      position: inherit;
      @media screen and (max-width: 768px) {
        margin-bottom: 10PX;
        font-size: 14px;
      }
    }
  }
}
</style>